import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        blocks: [],
        trainers: [],
        dragging: false,
    },
    // Called by commit()
    mutations: {
        SET_TRAINERS(state, trainers) {
            state.trainers = trainers;
        },
        START_DRAGGING(state) {
            state.dragging = true;
        },
        STOP_DRAGGING(state) {
            state.dragging = false;
        },
        SET_BLOCKS(state, blocks) {
            if (typeof blocks == 'undefined' || !blocks) {
                return;
            }

            // Using spread syntax to create copy of array. See Vue reactivity
            Vue.set(state, 'blocks', [...blocks]);
        },
        ADD_BLOCK(state, block) {
            state.blocks.push(block);
        },
        UPDATE_BLOCK(state, block) {
            let updatedBlock = state.blocks.find(i => i.id == block.id);

            if (!updatedBlock) {
                throw new Error('Could not find block with id of ' + block.id + ' to update.');
            }

            Object.assign(updatedBlock, block);
        },
        REMOVE_BLOCK(state, block) {
            state.blocks = state.blocks.filter(i => i.id !== block.id);
        },
        SORT_BLOCKS(state) {
            state.blocks.sort((a, b) => a.position - b.position);
        },
        ADD_WIDGET(state, widget) {
            let block = state.blocks.find(block => block.id == widget.block_id);

            if (!block.widgets) {
                Vue.set(block, 'widgets', [widget]);
            } else {
                block.widgets.push(widget);
            }
        },
        UPDATE_WIDGET(state, widget) {
            let allWidgets = [].concat.apply([], state.blocks.map(block => block.widgets || []));

            let updatedWidget = widget.dummyId
                ? allWidgets.find(i => i.id == widget.dummyId)
                : allWidgets.find(i => i.id == widget.id);

            delete widget.dummyId; // Remove the dummy id in case it had been set
            Object.assign(updatedWidget, widget);
        },
        REMOVE_WIDGET(state, widget) {
            let block = state.blocks.find(block => block.id == widget.block_id);

            block.widgets = block.widgets.filter(i => i.id != widget.id);
        },
    },
    getters: {
        getBlock: (state) => (id) => {
            return state.blocks.find(block => block.id == id);
        },
        getWidget: (state) => (id) => {
            let allWidgets = [].concat.apply([], state.blocks.map(block => block.widgets || []))
            return allWidgets.find(widget => widget.id == id);
        },
    },
    // Called by dispatch()
    actions: {
        addBlock({commit}, options) {
            return axios.post('/block', options)
                .then(response => commit('ADD_BLOCK', {...response.data, isNewRecord: true}))
                .then(response => commit('SORT_BLOCKS'))
        },
        saveBlock({commit}, block) {
            return axios.patch('/block/' + block.id, block)
                .then(response => commit('UPDATE_BLOCK', response.data))
                .then(response => commit('SORT_BLOCKS'))
        },
        deleteBlock({commit}, block) {
            return axios.delete('/block/' + block.id)
                .then(response => commit('REMOVE_BLOCK', block))
                .then(response => commit('SORT_BLOCKS'))
        },
        repositionBlock({commit}, swap) {
            return axios.post(`/block/${swap.old.id}/${swap.new.id}/${swap.after}`)
                .then(response => {
                    response.data.forEach(block => commit('UPDATE_BLOCK', block));
                    commit('SORT_BLOCKS');
                })
        },
        copyBlock({commit}, payload) {
            return axios.post(`/block/${payload.block.id}/copy/${payload.locale}`)
        },
        saveWidget({commit}, widget) {
            if (widget.id < 1) {
                // Dummy widgets are marked as such by a random float as their id.
                return axios.post('/widget', widget)
                    // This is passed on to the mutator to help identify it.
                    .then(response => commit('UPDATE_WIDGET', {...response.data, dummyId: widget.id}))
            } else {
                return axios.patch(`/widget/${widget.id}`, widget)
                    .then(response => commit('UPDATE_WIDGET', response.data))
            }
        },
        deleteWidget({commit}, widget) {
            return axios.delete(`/widget/${widget.id}`)
                .then(response => commit('REMOVE_WIDGET', widget));
        },
        repositionWidget({commit}, swap) {
            return axios.post(`/widget/${swap.old.id}/${swap.new.id}/${swap.after}`)
                .then(response => {
                    response.data.forEach(widget => commit('UPDATE_WIDGET', widget));
                })
        },
    }
});

export default store;



// WEBPACK FOOTER //
// ./resources/js/store.js